import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useUserContext } from "../context/user_context";

import EmployeeList from '../components/EmployeeList';
import ListView from '../components/ListView';

import Alert from '../components/Alert';
import ImageUploader from '../components/ImageUploader';
import { API_BASE_URL } from '../utils/apiConfig';
import { useHistory } from 'react-router-dom';
import loadingImage from '../images/preloader.gif';

function AddEmployee() {

    const [image, setImage] = useState('');
    const [previewImage, setPreviewImage] = useState('https://github.com/OlgaKoplik/CodePen/blob/master/profile.jpg?raw=true');
    const [altText, setAltText] = useState('');
    const history = useHistory();
    const { isLoggedIn, user, login } = useUserContext();
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState({ show: false, msg: '', type: '' });
    const [list, setList] = useState([]);
    const [showAddEmployee, setShowAddEmployee] = useState(false);
    const [formData, setFormData] = useState({
        userImage: '',
        firstName: '',
        lastName: '',
        dob: '',
        gender: '',
        email: '',
        phone: '',
        roleId: '',
        country: 'IND',
        countryCode: '+91',
        sourceSystem: 'WEB',
        referredBy: user.results.userId

    });

    // fetch and display in home scree with employee details
    const fetchEmployee = async () => {
        try {
            setIsLoading(true);
            const apiUrl = `${API_BASE_URL}/employee/all`;
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user?.results?.token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch subscribers');
            }

            const data = await response.json();
            ;
            setList(data?.results);
            setIsLoading(false);
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEmployee();
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };
    const handleImageChange = (e) => {
        console.log('check');
        const selectedImage = e.target.files[0];
        if (selectedImage) {
            setImage(selectedImage);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(selectedImage);
            setAltText(selectedImage.name);
        }
    };

    const showAlert = (show = false, type = '', msg = '') => {
        setAlert({ show, type, msg });
    };

    const uploadImageToServer = async () => {
        console.log('trap');
        const formData = new FormData();
        console.log(formData);
        formData.append('file', image);

        try {
            const response = await fetch(`${API_BASE_URL}/file-upload`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to upload image to the server');
            }

            const responseData = await response.json();

            return responseData.results.key; // Replace with the actual key where the image is stored

        } catch (error) {
            throw new Error('Error uploading image to the server');
        }
    };

    const refreshList = () => {
        // Trigger a re-fetch of the employee data
        setIsLoading(true); // Set loading state to true while fetching
        fetchEmployee();
    };

    const handleSubmit = async (e) => {

        e.preventDefault();
        setIsLoading(true);
        try {
            // Upload image to the s3 server and return the key
            //const imageUrlFromS3Bucket = await uploadImageToServer();
            const imageUrlFromS3Bucket = "https://laterneedtochange";
            if (imageUrlFromS3Bucket) {
                // FormData is already updated in the useEffect, so you can directly use it
                const apiUrl = `${API_BASE_URL}/employee`;

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${user?.results?.token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ...formData,
                        userImage: imageUrlFromS3Bucket,
                    }),
                });

                if (response.ok) {
                    // Handle successful response
                    const responseData = await response.json();
                    console.log(responseData);
                    showAlert(true, 'success', responseData.message);
                    refreshList();
                    toggleList();

                    // Reset form data after successful submission
                    setFormData({
                        userImage: '',
                        firstName: '',
                        lastName: '',
                        dob: '',
                        gender: '',
                        email: '',
                        phone: '',
                        roleId: '',
                        country: 'IND',
                        countryCode: '+91',
                        sourceSystem: 'WEB',
                        referredBy: user.results.userId,
                    });

                    // Reset the ImageUploader component
                    setImage('');
                    setPreviewImage('https://github.com/OlgaKoplik/CodePen/blob/master/profile.jpg?raw=true');
                    setAltText('');
                } else {
                    // Handle error response
                    const errorResponse = await response.json();
                    showAlert(true, 'danger', errorResponse.message);
                }
            } else {
                // Handle case where imageUrl is not available
                showAlert(true, 'danger', 'Error uploading image to the s3 bucket');
            }
        } catch (error) {
            // Handle any other errors during the process
            console.error('Error:', error);
            showAlert(true, 'danger', 'Error occurred while submitting');
        } finally {
            // Set loading state to false regardless of success or failure
            setIsLoading(false);
        }
    };


    const toggleList = () => {
        setShowAddEmployee(!showAddEmployee);
        // Reset form data when closing the modal
        if (!showAddEmployee) {
            setPreviewImage('https://github.com/OlgaKoplik/CodePen/blob/master/profile.jpg?raw=true');
            setFormData({
                userImage: '',
                firstName: '',
                lastName: '',
                dob: '',
                gender: '',
                email: '',
                phone: '',
                roleId: '',
                country: 'IND',
                countryCode: '+91',
                sourceSystem: 'WEB',
                referredBy: user.results.userId
            });
        }
    };
    const removeItem = async (id, roleid) => {
        try {

            console.log('came in deletion')
            console.log(id);
            console.log(roleid);
            const apiUrl = `${API_BASE_URL}/employee/${id}?roleid=${roleid}`;

            const response = await fetch(apiUrl, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${user?.results?.token}`,
                },

            });
            console.log('deletion response');
            console.log(response);
            if (response.ok) {
                refreshList();
                // Handle successful response
                const responseData = await response.json();
                showAlert(true, 'success', responseData.message);

                // After successful deletion, update the list state
                // with the remaining employees excluding the deleted one
                setList(prevList => prevList.filter(item => item.id !== id || item.roleid !== roleid));
            } else {
                // Handle error response
                const errorResponse = await response.json();
                showAlert(true, 'danger', errorResponse.message);
            }
        } catch (error) {
            // Handle any other errors during the process
            console.error('Error:', error);
            showAlert(true, 'danger', 'Error occurred while deleting');
        }
    };

    const editItem = (id) => {

    };


    const handleBackButtonClick = () => {
        history.push('/home'); // Replace '/' with the actual URL of your home page
    };

    if (isLoading) {
        return (
            <>
                <img src={loadingImage} className='loading-img' alt='loding' />
                <div className="placeholder" style={{ height: '50vh' }}></div>
            </>
        );
    }


    const isButtonDisabled = !formData.firstName || !formData.lastName || !formData.dob || !formData.gender || !formData.email || !formData.phone || !formData.roleId;
    return (
        <Wrapper className='section-center'>
            <div className="headercontainer">
                <button className='add-employee-btn' onClick={toggleList}>
                    Add Employee
                </button>
            </div>
            {alert.show && <Alert {...alert} removeAlert={showAlert} list={list} />}
            {list?.length > 0 && (

                <EmployeeList items={list} removeItem={removeItem} editItem={editItem} toggleList={toggleList} />
            )}






            {showAddEmployee && (
                <div className='list-modal'>
                    <button className='close-list-btn' onClick={toggleList}>
                        Close
                    </button>
                    <h3>Add Employee Details</h3>
                    <ImageUploader
                        onChange={handleImageChange}
                        previewImage={previewImage}
                        altText={altText}
                        id="photo-upload"
                    />
                    <form className="form" onSubmit={handleSubmit}>

                        <input className="formInput" type="text" placeholder="First name" name="firstName"
                            value={formData.firstName} onChange={handleChange} />
                        <input className="formInput" type="text" placeholder="Last name" name="lastName" value={formData.lastName} onChange={handleChange} />

                        <input className="formInput" type="date" placeholder="Date of Birth" name="dob" onChange={handleChange} value={formData.dob} />

                        <div className="gender">

                            <div className="gender-options">
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="male"
                                        onChange={handleChange}
                                        checked={formData.gender === 'male'}
                                    />
                                    Male
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="female"
                                        onChange={handleChange}
                                        checked={formData.gender === 'female'}
                                    />
                                    Female
                                </label>
                            </div>
                        </div>
                        <input className="formInput" type="email" placeholder="email" name="email"
                            value={formData.email} onChange={handleChange} />
                        <input className="formInput" type="phone" placeholder="phone" name="phone" value={formData.phone} onChange={handleChange} />
                        <div className="formInput">
                            <label htmlFor="role">Role</label>
                            <select
                                id="role"
                                name="roleId"
                                value={formData.roleId}
                                onChange={handleChange}
                            >
                                <option value="" disabled>Select a role</option>
                                <option value="3">Manager</option>
                                <option value="4">Accountant</option>
                                <option value="5">Collector</option>
                            </select>
                        </div>


                        <button
                            className={`formSubmit ${isButtonDisabled || isLoading ? 'disabled' : ''}`}
                            type="submit"
                            disabled={isButtonDisabled || isLoading}
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmit(e);
                            }}
                        >
                            {isLoading ? 'Updating Up...' : 'Save'}
                        </button>

                    </form>


                </div>
            )}

        </Wrapper>
    );
}
const Wrapper = styled.section`
display: flex;
flex-direction: column;

.form {
    display: flex;
    padding: 10px;
    flex-direction: column;
    width: 350px;
    height: 300px;
}
.formInput {
    border-radius: 5px;
    border-color: #e5e5e5;
    border-style: solid;
    border-width: 0.5px;
    margin-bottom: 10px;
    padding: 10px;
}

.formSubmit {
    cursor:pointer;
    border-radius: 5px;
    background-color:#cd3240;
    border: 2px solid transparent;
    color: white; 
    width: 330px;
    padding-top: 8px;
margin-top:2px;
align-items: center;
}
/* Disabled button style */
.formSubmit.disabled {
    background-color: #ccc; /* Change the background color when disabled */
    cursor: not-allowed; /* Change cursor to not-allowed when disabled */
}

  
  .p {
    margin-top:1rem;
  }
  @media (min-width: 992px) 
  {
    height: calc(100vh - 5rem);
    
  }
  .alert {
    margin-bottom: 1rem;
    height: 1.25rem;
    display: grid;
    align-items: center;
    text-align: center;
    font-size: 0.7rem;
    border-radius: 0.25rem;
    letter-spacing: var(--spacing);
    text-transform: capitalize;
  }
  
  .alert-danger {
    color: #721c24;
    background: #f8d7da;
  }
  
  .alert-success {
    color: #155724;
    background: #d4edda;
  }
  
.gender{
  padding-top:10px;
}
  .gender-options {
    display: flex;
    justify-content: space-between;
    width: 150px; /* Adjust the width of the container as needed */
    
  }  


  .headercontainer {
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-content: space-between; /* Distribute space between items */   
    
      }
  .add-employee-btn {    
    position: absolute;
    top: 0.1 rem; /* Adjust the value as needed */
    right: 6rem; /* Adjust the value as needed */
    padding: 0.5rem;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    color: var(--clr-grey-1);
    transition: color 0.2s;
    background: var(--clr-red-dark); /* Use your application's primary color */
    border: none;
    color: var(--clr-white); /* Use an appropriate text color for readability */
    border-radius: var(--radius);
  }
  
  .add-employee-btn:hover {
    background: var(--clr-primary-5); /* Change color on hover to match your theme */
  }
  .close-list-btn{
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.5rem;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    color: var(--clr-grey-1);
    transition: color 0.2s;
    background: var(--clr-red-dark); /* Use your application's primary color */
    border: none;
    color: var(--clr-white); /* Use an appropriate text color for readability */
    border-radius: var(--radius);
   
  }

  /* styles for employer list */
  .employer-list {
    position: relative;
   width:700px;    
   padding: 1rem;
        
    
  }
  
  /* styles for employer item wise */
  .employer-item {
    display: flex;
    gap: 40px;
    margin-top: 2rem;  
    margin-bottom: 1rem;
    transition: var(--transition);
    padding: 0.25rem 5rem;
    border-radius: var(--radius);
    align-items: center;
    text-transform: capitalize;
      img {
      height: 100%;
      width: 45px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  
  .employer-item:hover {
    color: var(--clr-grey-5);
    background: var(--clr-grey-10);
    //for blue bar behind
    width:40rem;
  }
  
  .employer-item:hover .title {
    color: var(--clr-grey-5);
    
  }
  
  .title {
    
    color: var(--clr-grey-1);
    letter-spacing: 2px;
    transition: var(--transition);
  }
  
  .edit-btn,
  .delete-btn {
    background: transparent;
    border-color: transparent;
    cursor: pointer;
    font-size: 0.7rem;
    margin: 0 0.15rem;
    transition: var(--transition);
  }
  
  .edit-btn {
    color: var(--clr-green-light);
  }
  
  .edit-btn:hover {
    color: var(--clr-green-dark);
  }
  
  .delete-btn {
    color: var(--clr-red-light);
  }
  
  .delete-btn:hover {
    color: var(--clr-red-dark);
  }
 //styles for employer item


 .list-modal {
    display:flex;
    flex-direction: column;
align-items: center; 
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 600px;
    background: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    
    padding: 1rem;
    z-index: 1000; /* Ensure it appears above other elements */
    @media (max-width: 768px) {
        width: 90%; /* Adjust the width for screens with a max-width of 768px */
        height: 90vh; /* Adjust the height for smaller screens */
        padding: 0.5rem; /* Reduce padding for smaller screens */
      }
    
      @media (max-width: 480px) {
        width: 95%; /* Further adjust the width for screens with a max-width of 480px */
        height: 85vh; /* Further adjust the height for smaller screens */
        padding: 0.25rem; /* Reduce padding for smaller screens */
      }
  }
  .listheader{    
    padding-left:12rem;
    margin-bottom:0.1rem;
      }
      .underline
      {      
        text-decoration: underline;
              }
   
  
`
export default AddEmployee;
